// @ts-nocheck
// "בחר/י פרק" (8.10.2026): which chapters the signed-in reader picked
// (migration 0048, my_chapter_picks). Full-access readers get full=true and
// never hit the pick quota. Anonymous readers get an empty set.
import { useCallback, useEffect, useState } from "react";
import { supabase } from "./supabase";
import { useAuth } from "./useAuth";

export type Picks = { chapters: number[]; left: number; full: boolean; error?: boolean };
const EMPTY: Picks = { chapters: [], left: 0, full: false };
// When the server could not answer we must not show every chapter as locked
// (13.10: a reader saw "89 ₪" on all rows while the RPC was slow/failing).
const UNKNOWN: Picks = { chapters: [], left: 0, full: false, error: true };

export function usePicks() {
  const { user, loading: authLoading } = useAuth();
  const [picks, setPicks] = useState<Picks | null>(null);

  const refresh = useCallback(async () => {
    if (!user) {
      setPicks(EMPTY);
      return;
    }
    const { data, error } = await supabase.rpc("my_chapter_picks");
    if (error || !data) {
      if (error) console.warn("my_chapter_picks failed", error);
      setPicks(UNKNOWN);
      return;
    }
    setPicks({
      chapters: Array.isArray(data.chapters) ? data.chapters.map(Number) : [],
      left: Number(data.left ?? 0),
      full: !!data.full,
    });
  }, [user]);

  useEffect(() => {
    if (authLoading) return;
    refresh();
  }, [authLoading, refresh]);

  const canRead = useCallback(
    (chapter: number) =>
      chapter === 1 || !!picks?.full || !!picks?.chapters.includes(chapter),
    [picks]
  );

  return { picks: picks ?? EMPTY, loading: picks === null, canRead, refresh };
}
